import { render } from "./Features.vue?vue&type=template&id=24e50f65&scoped=true"
import script from "./Features.vue?vue&type=script&lang=js"
export * from "./Features.vue?vue&type=script&lang=js"

import "./Features.vue?vue&type=style&index=0&id=24e50f65&scoped=true&lang=css"

import exportComponent from "/home/rainnya_lime/桌面/project/waydro.id/Waydro.id/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24e50f65"]])

export default __exports__